import React from "react";

import { addUtmParamsToSectionNavigators } from "../../../Common/utils/NavigationUtils";
import { useValidateQueryParams } from "../../../Common/utils/hooks/QueryParams/useValidateQueryParams";

import Timer from "../Timer/Timer";

import "./FixedBanner.css";

export default function FixedBanner() {
  const verifiedUtm = useValidateQueryParams();
  return (
    <section className="section_4">
      <div className="div_block_183198ad">
        <Timer imgTxt={"fixed-banner"} txtColor={"#fbbf24"} />
        <a
          referrerPolicy="no-referrer-when-downgrade"
          id="book-a-free-live-section-sticky"
          href={addUtmParamsToSectionNavigators(
            verifiedUtm,
            "#book-my-session"
          )}
          className="book_a_free_live_session"
        >
          Book a Free Live Session
        </a>
      </div>
    </section>
  );
}
